import { TIIVII_API_GET_EVENT, TIIVII_CHECK_USER_PASS_ENDPOINT, TIIVII_UPDATE_USER_ENDPOINT } from "../utils/constants";
import axios from "axios";
import { buildUrl, getOptions } from "./commonService";

export const checkUserPassService = body => {
  const options = getOptions({});
  return axios.post(TIIVII_CHECK_USER_PASS_ENDPOINT, body, options);
};

export const updateUserService = (username, body, callback, errorCallback) => {
  const config = getOptions({});
  const url = buildUrl(TIIVII_UPDATE_USER_ENDPOINT, {
    username,
  });

  axios
    .patch(url, body, config)
    .then(response => {
      callback(response.data);
    })
    .catch(error => {
      errorCallback(error);
    });
};

export const getUserService = (username, callback, errorCallback) => {
  const options = getOptions({});
  const url = buildUrl(TIIVII_UPDATE_USER_ENDPOINT, { username });
  axios
    .get(url, options)
    .then(response => {
      callback(response);
    })
    .catch(error => {
      errorCallback(error);
    });
};
